import { Inject, Injectable } from "@angular/core";
import { KeyCloakOptions } from "../interfaces/keycloak-options.config";
import { KeyCloakUrls } from "../interfaces/keycloak-urls.config";
// import { APP_SETTINGS } from 'shared-library';
import { ENV_CONFIG_UM } from "../tokens/env.token";

@Injectable({
  providedIn: "root",
})

//* Represents the environment variables for the project that can be
//* injected anywhere in our application using Angular dependency injection

//? If env.js cannot be loaded, the application will fall back to
//? the default values defined in this class.
export class EnvService {
  private APP_SETTINGS: any = "";
  public scopeBaseUrl: string;
  public baseUrl: string;
  public proxyApiUrl: string; // for third party api calls
  public product_baseUrl: string;
  public keyCloakUrls: KeyCloakUrls;
  public keyCloakOptions: KeyCloakOptions;

  public applicationBaseUrl: string = "";

  public appRedirectUrl: string = "home";

  public userMgmtRedirectUrl: string = "home";

  public copyRightText: string = "Stanley";

  public headerAppName: string = "Stanley  ";
  public REALM_DETAIL_KEY : string = "realmDetails";

  public isCustomerDropdownRequired: boolean = false;

  public customerDropDownValues: any = [];

  constructor(@Inject(ENV_CONFIG_UM) private env: any) {
    this.APP_SETTINGS = env;

    this.scopeBaseUrl = this.APP_SETTINGS.URL_MAPPING.PROJ_API + "scope/";
    this.baseUrl = this.APP_SETTINGS.URL_MAPPING.USERMGMT_API;
    this.product_baseUrl = this.APP_SETTINGS.URL_MAPPING.PROJ_API;
    this.proxyApiUrl = this.APP_SETTINGS.URL_MAPPING.PROXY_API;
    this.keyCloakUrls = {
      baseUrl: this.APP_SETTINGS.KEYCLOAK_URLS.BASE_URL,
      redirectUrl: this.APP_SETTINGS.KEYCLOAK_URLS.REDIRECT_URL,
      logoutUrl: this.APP_SETTINGS.KEYCLOAK_URLS.LOGOUT_URL,
    };

    this.keyCloakOptions = {
      clientId: this.APP_SETTINGS.CLIENT_ID,
      realm: this.APP_SETTINGS.REALM_NAME,
      keyCloakUrls: {
        baseUrl: this.keyCloakUrls.baseUrl,
        redirectUrl: this.keyCloakUrls.redirectUrl,
        logoutUrl: this.keyCloakUrls.logoutUrl,
      },
    };
  }
}
